var SENTRY_RELEASE;SENTRY_RELEASE={name: "Brillen CA", version: "1.63.0"};